define('drops/modals',[],function () {
    'use strict';

    var currentZIndexOfRealModals = 600000;
    var zIndexForPopups = 10000;

    return {

        getZIndexForPopups: function () {
            return currentZIndexOfRealModals + zIndexForPopups;
        },

        getNextZIndex: function () {
            return currentZIndexOfRealModals++;
        }

    };
});

